module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"investmentCostsComparisson":"Szenarienvergleich","investmentCostsPath":"Übersicht","pvNpvComparisson":"Wirtschaftlichkeit Photovoltaik"}}')
  delete Component.options._Ctor
}
